<template>
  <div class="customer-item-body">
    <ul class="customer-body-ul">
      <li class="customer-body-li" v-for="(item,index) in customerTabList" :key="index" :class="customerTabDirector == index ? 'customer-body-li-active' :''"   @click="selectTabType(index)" >{{item.title}}</li>
    </ul>
    <div class="customer-body-center">
      <div class="customer-body-center-title" v-if="customerTabDirector != 3">
        <span class="customer-body-center-span">{{customerTitle}}</span>
      </div>
      <div class="customer-body-item" v-if="customerTabDirector == 0">
          <div class="customer-question-body">
            <div class="customer-question-icon">Q</div>
            <div class="customer-question-span">游戏无法登陆？</div>
          </div>
          <div class="customer-answer-body">
            <div class="customer-answer-icon">A</div>
            <div class="customer-answer-span">
              <p>可以尝试以下两种解决方法:</p>
              <p>1. 请关闭浏览器并下载安装最新FLASH插件：<a href="https://www.flash.cn/cdm/latest/flashplayerpp_install_cn_web.exe">https://www.flash.cn/cdm/latest/flashplayerpp_install_cn_web.exe</a></p>
              <p>2. 清理下IE浏览器无加载版缓存以及刷新下DNS服务器，就可以缓解此问题。友情提醒 ：在玩页游的过程中，需要经常进行IE缓存的清理，这样可以让游戏更加流畅</p>
            </div>
          </div>
      </div>
      <div class="customer-body-item" v-if="customerTabDirector == 1">
          <div class="customer-question-body">
            <div class="customer-question-icon">Q</div>
            <div class="customer-question-span">为什么我的充值未到账？</div>
          </div>
          <div class="customer-answer-body">
            <div class="customer-answer-icon">A</div>
            <div class="customer-answer-span">
              <p>1. 如果您已完成支付且扣款成功,但您所在的游戏服务器里没有收到游戏币,这是网络延迟影响导致的,
                建议您耐心等待15分钟后再次登陆游戏中确认,如有的游戏在跨服中,
                可等到退出跨服后在重新登陆游戏</p>
              <p>2. 如仍然没有获取相应的游戏币,您可以联系<a :href="webSite.one_qq_url" target="_blank" style="color: #ff2801;">【在线客服】</a>
                ,提供游戏账号和官网充值订单号,我们会为您尽快核实处理</p>
            </div>
          </div>
      </div>
      <div class="customer-body-item" v-if="customerTabDirector == 1">
        <div class="customer-question-body">
          <div class="customer-question-icon">Q</div>
          <div class="customer-question-span">游戏充值充错了区服怎么办?</div>
        </div>
        <div class="customer-answer-body">
          <div class="customer-answer-icon">A</div>
          <div class="customer-answer-span">
            <p>1. 充错区服别着急,充值错的区服内没有可用角色,及时联系<a :href="webSite.one_qq_url" target="_blank" style="color: #ff2801;">【在线客服】</a>按照客服提示提供相应的信息来转移</p>
            <p>2. (错误区服内没有可用角色才可转移,没有角色时请勿创建角色否则无法转移,详情请联系<a :href="webSite.one_qq_url" target="_blank" style="color: #ff2801;">【在线客服】</a>咨询)</p>
          </div>
        </div>
      </div>
      <div class="customer-body-item" v-if="customerTabDirector == 2">
          <div class="customer-question-body">
            <div class="customer-question-icon">Q</div>
            <div class="customer-question-span">我的账号被别人修改了密码或者我密码忘记了如何找回?</div>
          </div>
          <div class="customer-answer-body">
            <div class="customer-answer-icon">A</div>
            <div class="customer-answer-span">
              <p>在平台登陆处有一个"忘记密码",点击后之后可以通过绑定手机找回密码,如果没有绑定手机也可以联系<a :href="webSite.one_qq_url" target="_blank" style="color: #ff2801;">【在线客服】</a>,在核实玩家身份后找回密码</p>
            </div>
          </div>
      </div>
      <div class="customer-body-item" v-if="customerTabDirector == 2">
        <div class="customer-question-body">
          <div class="customer-question-icon">Q</div>
          <div class="customer-question-span">我使用QQ或者微信登陆,不知道游戏账号密码怎么办?</div>
        </div>
        <div class="customer-answer-body">
          <div class="customer-answer-icon">A</div>
          <div class="customer-answer-span">
            <p>1. 使用QQ或者微信登陆后时会自动生成一个样式为qq_******或者wx_*******的账号在平台个人中心可以查看,密码是你之前设置过的密码</p>
            <p>2. 如果遗忘的话登陆界面处点击"忘记密码",可以通过绑定手机或者邮箱找回;如果没有绑定手机或者邮箱也可以联系<a :href="webSite.one_qq_url" target="_blank" style="color: #ff2801;">【在线客服】</a>,核实玩家身份后找回密码</p>
          </div>
        </div>
      </div>
      <div class="customer-body-item" v-if="customerTabDirector == 2">
        <div class="customer-question-body">
          <div class="customer-question-icon">Q</div>
          <div class="customer-question-span">账号登陆异常?</div>
        </div>
        <div class="customer-answer-body">
          <div class="customer-answer-icon">A</div>
          <div class="customer-answer-span">
            <p>一旦发现账号登陆异常,有可能是密码泄漏,请您及时修改好密码</p>
          </div>
        </div>
      </div>
      <div class="customer-body-safe" v-if="customerTabDirector == 3">
        <Steps :current="stepDirector"  style="margin: 75px 0;">
          <Step title="步骤1"></Step>
          <Step title="步骤2"></Step>
          <Step title="步骤3"></Step>
          <Step title="步骤4"></Step>
        </Steps>
        <div class="customer-step-body" v-if="stepDirector == 0">
          <span class="customer-step-span">确认账号:<input type="text" v-model="customerBean.title" placeholder="请输入账号" 
              class="customer-step-input"></span>
          <Button type="error"  @click="nextStep(0)" class="customer-step-button">下一步</Button>
        </div>
        <div class="customer-step-body" v-if="stepDirector == 1">
          <span class="customer-step-span">
            验证码:
            <input type="text" v-model="customerBean.code" placeholder="请输入验证码" 
              class="customer-step-input">
            <div class="safe-body-send" @click="sendRetrieveUser" :class="sendCodeState ? 'safe-body-disable-send':'safe-body-able-send'">{{codeButton}}</div>
          </span>
          <Button type="error"  @click="nextStep(1)"  class="customer-step-button">下一步</Button>
        </div>
        <div class="customer-step-body" v-if="stepDirector == 2">
          <span class="customer-step-span">密码：
            <input type="password" v-model="customerBean.password" placeholder="请输入密码" class="customer-step-input"></span>
          <span class="customer-step-span">确认密码：
            <input type="password" v-model="tempPassword" placeholder="请确认密码" class="customer-step-input"></span>
          <Button type="error"  @click="nextStep(2)"  class="customer-step-button">下一步</Button>
        </div>
        <div class="customer-step-body" v-if="stepDirector == 3">
          <span class="customer-step-span" style="text-align: center;font-size: 24px;color: #3ece83;">密码更新成功!跳转中.....</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import JSEncrypt from "jsencrypt"
  export default {
    name: "Question",
    metaInfo(){
      return {
        title:"客服中心详情_"+this.$store.state.home.title,
        meta:[
          { name:'keywords', content:this.$store.state.home.keywords},
          { name:'description',content:this.$store.state.home.description}
        ]
      }
    },
    asyncData({store,route}){
      return store.dispatch('initSeo',{store:store});
    },
    data() {
      return {
        customerTitle:'',
        customerTabDirector: 0,
        stepDirector: 0,
        LoginBoxShow:true,
        LoginAfterBoxshow:false,
        selectList:[],
        customerBean:{
          title:"",
          code:"",
          type:0,
          password:""
        },
        tempPassword:"",
        customerTabList:[
          { id:0, title:'游戏问题'},
          { id:1,	title:'充值问题'},
          {	id:2,	title:'常见问题'},
          {	id:3,	title:'密码找回'},
        ],
        codeTimer:'',
        codeValue:60,
        codeButton:"发送",
        sendCodeState:false,
      };
    },
    mounted(){
      let type = this.$route.query.index;
      if(type != undefined){
        this.selectTabType(type);
      }else{
        this.selectTabType(0);
      }
    },
    beforeDestroy(){
      clearInterval(this.codeTimer);
    },
    computed:{
      webSite(){
        return this.$store.state.home.webSite;
      },
    },
    methods: {
      nextStep(value) {
        if(value == 0){
          if(this.customerBean.title.length > 0){
            this.sendRetrieveUser();
          }else{
            alert("请输入你要找回的账号!");
          }
        }else if(value == 1){
          if(this.customerBean.code.length >= 6){
            this.checkRetrieveCode();
          }else{
            alert("请输入验证码!");
          }
        }else if(value == 2){
          if(this.customerBean.password.length>=6&&this.customerBean.password == this.tempPassword){
            this.updateRetrievePassword();
          }else{
            alert("请输入正确的密码!");
          }
        }
      },
      sendRetrieveUser(){
        if(!this.sendCodeState){
          this.$http.post('/send_web_retrieve_user',{
            data: this.customerBean.title
          }).then(res=>{
            if(res.data.code ==2000){
              if(res.data.data == 1){
                //手机
                if(res.data.total == 1){
                  alert('手机验证码发送成功!');
                  this.stepDirector += 1;
                  this.customerBean.type = res.data.data;
                  this.setCodeTimer();
                  this.sendCodeState = true;    
                }else{
                  alert('手机验证码发送失败!');
                }
              }else if(res.data.data == 2){
                //邮箱
                if(res.data.total == 1){
                  alert("邮箱验证码发送成功!");
                  this.stepDirector += 1;
                  this.customerBean.type = res.data.data;
                  this.setCodeTimer();
                  this.sendCodeState = true;    
                }else{
                  alert("邮箱验证码发送失败!");
                }
              }else{
                //没有
                alert("没有绑定手机号和邮箱,请联系客服更改!");
              }  
            }else{
              alert('请输入正确的账号!');
            }
          });
        }
      },
      selectTabType(value){
        this.customerTitle = this.customerTabList[value].title;
        this.customerTabDirector = value;
      },
      checkRetrieveCode(){
        this.$http.post('/check_web_retrieve_code?account='+this.customerBean.title+"&code="
        +this.customerBean.code+"&type="+this.customerBean.type,{})
        .then(res=>{
          if(res.data.code ==2000){
            this.stepDirector += 1;
            clearInterval(this.codeTimer);    
          }else{
            alert('请输入正确的验证码!');
          }
        })
      },
      updateRetrievePassword(){
        this.$http.post("/check_web_user",{},
        { params:{account:this.customerBean.title}})
        .then(res=>{
          if(res.data.code == 2000){
            let encrypt = new JSEncrypt();
            // 设置公钥
            encrypt.setPublicKey(res.data.data);
              // 加密数据
            this.$http.post('/update_web_retrieve_password',{
              data:{
                account:this.customerBean.title,
                data:arrayBufferToBase64(encrypt.encryptLong(JSON.stringify(this.customerBean)))}
            }).then(res=>{
              if(res.data.code === 2000){
                alert("修改成功!跳转中....");
                this.$router.push({path:"/"});
                this.stepDirector += 1;
              }else{
                alert(res.data.msg);
              }     
            });  
          }
        });
      },
      setCodeTimer(){
        this.codeTimer = setInterval(this.codeInterval,1000);
      },
      codeInterval(){
        this.codeValue --;
        if(this.codeValue <=0){
          this.sendCodeState = false;
          this.codeButton = "发送";
          clearInterval(this.codeTimer);
        }else{
          this.codeButton = this.codeValue +"秒";
        }
      }
    }
  };
  JSEncrypt.prototype.encryptLong = function(string){
    var k = this.getKey(); 
    try {
      var ct = "";
      var bytes = new Array();
      bytes.push(0);
      var byteNo = 0;
      var len, c;
      len = string.length;
      var temp = 0;
      for (var i = 0; i < len; i++) {
        c = string.charCodeAt(i);
        if (c >= 0x010000 && c <= 0x10FFFF) {
          byteNo += 4;
        } else if (c >= 0x000800 && c <= 0x00FFFF) {
          byteNo += 3;
        } else if (c >= 0x000080 && c <= 0x0007FF) {
          byteNo += 2;
        } else {
          byteNo += 1;
        }
        if ((byteNo % 117) >= 114 || (byteNo % 117) == 0) {
          if (byteNo - temp >= 114) {
            bytes.push(i);
            temp = byteNo;
          }
        }
      }
      //2.截取字符串并分段加密
      if (bytes.length > 1) {
        for (var i = 0; i < bytes.length - 1; i++) {
          var str;
          if (i == 0) {
            str = string.substring(0, bytes[i + 1] + 1);
          } else {
            str = string.substring(bytes[i] + 1, bytes[i + 1] + 1);
          }
          var t1 = k.encrypt(str);
          ct += t1;
        };
        if (bytes[bytes.length - 1] != string.length - 1) {
          var lastStr = string.substring(bytes[bytes.length - 1] + 1);
          ct += k.encrypt(lastStr);
        }
        return hexToBytes(ct);
      }
      var t = k.encrypt(string);
      var y = hexToBytes(t);
      return y;
    } catch (ex) {
      return false;
    }
  }

  function hexToBytes(hex) {
    for (var bytes = [], c = 0; c < hex.length; c += 2)
      bytes.push(parseInt(hex.substr(c, 2), 16));
    return bytes; 
  }

  function arrayBufferToBase64(buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }
</script>
<style src="@/assets/css/question.css" scoped></style>
